import { WidgetActionMethod } from '../../WidgetVariant';

enum VariantSpecificActionMethod {
  Collapse = 'collapse',
  Expand = 'expand',
  Hide = 'hide',
  Show = 'show',
  InitiateExpertChat = 'initiateExpertChat',
  InitiateInteractionModelChat = 'initiateInteractionModelChat',
  InitiateSimplrChat = 'initiateChat',
}

export type ActionMethod = VariantSpecificActionMethod | WidgetActionMethod;

export const ActionMethod = {
  ...VariantSpecificActionMethod,
  ...WidgetActionMethod,
};
